import CpdForm from '../../common/CpdForm';

export default function CloneCpdForm() {
    return <CpdForm mode="Clone" />;
}
